export default __webpack_public_path__ + "static/media/instacart.f8221ef1.png";